import constants from './constants'
import rules from './rules'
import settings from './settings'

const utils = {
  getDuration: (date: string) => {
    const time: number = new Date(date).getTime() + 3600000
    const duration = { hours: 0, minutes: 0 }

    if (time) {
      const totalMinutes = time / 60000
      duration.hours = Math.floor(totalMinutes / 60)
      duration.minutes = Math.floor(totalMinutes % 60)
    }
    return duration
  },
  console,
  constants,
  rules,
  settings
}

export default utils
